export default __webpack_public_path__ + "static/media/home.838c7351.png";